import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getCategories } from "../../redux/actions/categories";
import { getCurrency } from "../../redux/actions/currencySelect";
import NavBar from "./NavBar/NavBar";
import Footer from "./Footer/Footer";
import Saturation from "./Saturation";
import ButtonWhatsApp from "./ButtonWhatsApp/ButtonWhatsApp";
import { daysRestriction } from "../../commons/helpers/daysRestriction";
import "./styles.css";

const Layout = (props) => {
  const {
    getCategories,
    children,
    isAuthenticated,
    categories,
    location,
    getCurrency,
  } = props;
  useEffect(() => {
    getCategories();
    let currency = localStorage.getItem("currency");
    if (currency === "USD") {
      getCurrency();
    }
  }, [getCategories, getCurrency]);
  return (
    <>
      {location.pathname !== "/checkout" && (
        <NavBar user={isAuthenticated} categories={categories} />
      )}
      <div className="lyt-container">{children}</div>
      <Footer />
      {!daysRestriction() ? <ButtonWhatsApp /> : <Saturation />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth,
    categories: state.categories.categories,
  };
};

export default withRouter(
  connect(mapStateToProps, { getCategories, getCurrency })(Layout)
);
